module.exports = {

    links: null,
    elements: null,

    init: function ($container) {
        'use strict';

        this.links = $container
            ? $container.querySelectorAll('.mdl-accordion__button')
            : document.querySelectorAll('.mdl-accordion__button');

        if (!this.links.length) {
            return;
        }

        this.elements = document.querySelectorAll('.mdl-accordion__content');


        const that = this,
            msnryWrapper = $container
                ? $container.querySelectorAll('.msnry-wrapper-2')
                : document.querySelectorAll('.msnry-wrapper-2');

        if (msnryWrapper.length) {
            for (let i = 0; i < msnryWrapper.length; i++) {
                const imagesLoaded = require('imagesloaded'),
                    Masonry = require('masonry-layout'),
                    imgLoad = imagesLoaded(msnryWrapper[i]),
                    msnry = new Masonry(msnryWrapper[i], {
                        itemSelector: '.item',
                        columnWidth: '.item-sizer',
                        percentPosition: true
                    });

                imgLoad.on('done', function () {
                    msnry.layout();
                    msnry.once('layoutComplete', function () {
                        that.adjustElement(msnryWrapper[i].parentNode);
                    });
                });

            }
        } else {
            for (let i = 0; i < that.elements.length; i++) {
                that.adjustElement(that.elements[i]);
            }
        }

        for (let i = 0; i < this.links.length; i++) {
            this.links[i].onclick = this.toggleElement;
        }

        window.addEventListener('resize', function () {
            for (let i = 0; i < that.elements.length; i++) {
                that.adjustElement(that.elements[i]);
            }
        }, true);
    },

    adjustElement: function ($element) {
        'use strict';

        $element.style.marginTop = -window.getComputedStyle($element).height + 'px';
    },

    toggleElement: function ($event) {
        'use strict';

        const opened = document.querySelectorAll('.mdl-accordion--opened');
        let target = $event.target.parentNode;

        if (!target.classList.contains('mdl-accordion')) {
            target = target.parentNode;

            if (!target.classList.contains('mdl-accordion')) {
                target = target.parentNode;

                if (!target.classList.contains('mdl-accordion')) {
                    target = target.parentNode;
                }
            }
        }

        if (opened.length) {
            for (let i = 0; i < opened.length; i++) {
                if (opened[i] !== target) {
                    opened[i].classList.remove('mdl-accordion--opened');
                }
            }
        }

        target.classList.toggle('mdl-accordion--opened');
    }
};
